import { render, staticRenderFns } from "./pickUpCardNew.vue?vue&type=template&id=61cae69c&scoped=true&"
import script from "./pickUpCardNew.vue?vue&type=script&lang=js&"
export * from "./pickUpCardNew.vue?vue&type=script&lang=js&"
import style0 from "./pickUpCardNew.vue?vue&type=style&index=0&id=61cae69c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cae69c",
  null
  
)

export default component.exports